import { BrowserStorageApi } from '@/core/apis/browser_storage_api/browser_storage_api';
import { EBrowserStorageType } from '@/core/apis/browser_storage_api/browser_storage_api_types';
import { JSONHelper } from '@/core/apis/browser_storage_api/json_helper';
// import { Logger } from '@/shared/logger/logger';

export class StorageHandler<T> {
  protected _jSONHelper: JSONHelper<T>;
  protected _storageNameSpace: string;
  protected _defaultData: T;
  protected _storageProvider: EBrowserStorageType;
  protected _data: T | null;
  protected _dataFetched: boolean;

  constructor(
    storageNameSpace: string,
    defaultData: T,
    storageProvider: EBrowserStorageType = EBrowserStorageType.LOCALSTORAGE,
  ) {
    this._jSONHelper = new JSONHelper<T>();
    this._storageNameSpace = storageNameSpace;
    this._defaultData = defaultData;
    this._storageProvider = storageProvider;
    this._data = null;
    this._dataFetched = false;
  }

  set(data: T): boolean {
    const result = BrowserStorageApi.set_value({
      item_key: this._storageNameSpace,
      item_value: this._jSONHelper.safeStringify(data, ''),
      storage_provider: this._storageProvider,
    });

    if (!result.success) {
      // Logger.info('[ERROR] Failed to set data');
      return false;
    }

    this._data = data;
    this._dataFetched = true;
    return true;
  }

  protected fetchData(): T {
    const result = BrowserStorageApi.get_value({
      default: '',
      item_key: this._storageNameSpace,
      storage_provider: this._storageProvider,
    });

    if (result.success) {
      try {
        return this._jSONHelper.safeUnstringify(
          result.item_value,
          this._defaultData,
        );
      } catch {
        // Logger.info('[ERROR] Failed to parse data');
        return this._defaultData;
      }
    } else {
      return this._defaultData;
    }
  }

  get(): T {
    if (this._dataFetched) {
      return this._data === null ? this._defaultData : this._data;
    }

    this._data = this.fetchData();
    this._dataFetched = true;
    return this._data;
  }
}
